import { get } from 'lodash/fp';

const useSortArrayByAlphabets = () => {
  const sortedArray = (array, key) => array.sort((a, b) => get(key, a).localeCompare(get(key, b)));
  return sortedArray;
};

export default useSortArrayByAlphabets;
